import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { SortableContext } from "@dnd-kit/sortable";
import {
  Box,
  Button,
  Group,
  Text,
  Title
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { useState } from "react";
import { tblComboSetGroupModels } from "../../model/Comboset";
import FormChooseItem from "./FormChooseItem";
import SortableGroupItem from "./SortableGroupItem";

interface GroupItem {
  id?: number | null;
  groupName: string;
  sortOrder?: number;
  setId?: number | null;
  tblComboSetProdCommands?: any[];
}

type ItemGroupProps = {
  // onSetDataComboSet: (value: any) => void;
  dataGroupItem: tblComboSetGroupModels[] | [];
  setDataGroupItem: React.Dispatch<
    React.SetStateAction<tblComboSetGroupModels[]>
  >;
};

const ItemGroupV2 = ({
  // onSetDataComboSet,
  dataGroupItem,
  setDataGroupItem,
}: ItemGroupProps) => {
  // Hàm này để xử lý việc đổi tên cho nhóm sản phẩm
  const handleChangeNameComboSet = (value: string, indexGroup: number) => {
    setDataGroupItem((prevData) => {
      return prevData.map((itemGroup: GroupItem, idxGroup: number) => {
        if (indexGroup === idxGroup) {
          return { ...itemGroup, groupName: value };
        } else {
          return itemGroup;
        }
      });
    });
  };
  // Đoạn này để xử lý thêm sản phẩm mới vào trong nhóm
  const handleChooseItem = (
    items: Array<{
      id: number;
      itemName: string;
      unitSellingPrice: number | string;
      indexItem: number;
      indexGroup: number;
    }>
  ) => {
    console.log("handleChooseItem", items);
    console.log("dataGroupItem", dataGroupItem);
    if (!items || items.length === 0) return;
    setDataGroupItem((prevData: any) => {
      return prevData.map((itemGroup: GroupItem, idxGroup: number) => {
        console.log("itemGroup", itemGroup);
        // Process only groups that have items for them in our selection
        const itemsForThisGroup = items.filter(
          (item) => item.indexGroup === idxGroup
        );
        console.log("itemsForThisGroup", itemsForThisGroup);
        if (itemsForThisGroup.length > 0) {
          // Lấy danh sách sản phẩm cũ
          const oldProducts = itemGroup.tblComboSetProdCommands || [];
          console.log("oldProducts", oldProducts);
          // const updatedCommands = itemsForThisGroup.map((item, index) => ({
          const newProducts = itemsForThisGroup
            .filter(
              (item) => !oldProducts.some((old) => old.itemId === item.id)
            )
            .map((item, index) => ({
              itemId: item.id,
              itemName: item.itemName,
              itemPrice: item.unitSellingPrice,
              unitSellingPrice: item.unitSellingPrice,
              discoutValue: 0,
              discoutType: 1,
              isFirstRow: "",
              isFree: "",
              isHot: "",
              sortOrder: index + 1,
            }));

          // return { ...itemGroup, tblComboSetProdCommands: updatedCommands };
          // Ghép sản phẩm cũ + mới
          const updatedCommands = [...oldProducts, ...newProducts];
          // console.log("updatedCommands", updatedCommands);
          return { ...itemGroup, tblComboSetProdCommands: updatedCommands };
        } else {
          return itemGroup;
        }
      });
    });
  };
  // Hàm này để mở modal chọn chọn thêm sản phẩm cho vào nhóm sản phẩm
  const openModal = (indexItem: number, indexGroup: number) => {
    console.log("openmodal");
    modals.openConfirmModal({
      modalId: "item",
      title: (
        <div>
          <Title order={5}>Chọn sản phẩm thêm vào combo set</Title>
        </div>
      ),
      children: (
        <FormChooseItem
          onChooseItem={handleChooseItem}
          indexItem={indexItem}
          indexGroup={indexGroup}
          listItem={dataGroupItem[indexGroup]?.tblComboSetProdCommands || []}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleAddGroupItem = () => {
    setDataGroupItem([
      ...dataGroupItem,
      {
        groupName: "",
        tblComboSetProdCommands: [],
        sortOrder: dataGroupItem.length + 1,
      },
    ]);
  };

  const handleRemoveGroup = (indexGroup: number) => {
    const newData = [...dataGroupItem];
    newData.splice(indexGroup, 1);

    // Cập nhật lại sortOrder sau khi xóa nhóm
    const updatedGroups = newData.map((group, idx) => ({
      ...group,
      sortOrder: idx + 1,
    }));

    setDataGroupItem(updatedGroups);
  };

  const countEmptyGroups = () => {
    return dataGroupItem.filter(
      (group: GroupItem) =>
        group.groupName === "" &&
        (!group.tblComboSetProdCommands ||
          group.tblComboSetProdCommands.length === 0)
    ).length;
  };
  // const handleAddItem = (index: number) => {
  //   const data = [...dataGroupItem];
  //   const newData = data?.map((item: GroupItem, idx: number) => {
  //     if (index === idx) {
  //       return {
  //         ...item,
  //         tblComboSetProdCommands: [
  //           ...(item?.tblComboSetProdCommands || []),
  //           {
  //             id: 0,
  //             itemId: null,
  //             discoutValue: "",
  //             discoutType: null,
  //             isFirstRow: "",
  //             isFree: "",
  //             isHot: "",
  //           },
  //         ],
  //       };
  //     } else {
  //       return item;
  //     }
  //   });
  //   setDataGroupItem(newData);
  // };

  const handleMoveItem = (
    indexItem: number,
    indexGroup: number,
    direction: "up" | "down"
  ) => {
    setDataGroupItem((prevData) => {
      const newData = [...prevData];
      const products = [
        ...(newData[indexGroup]?.tblComboSetProdCommands || []),
      ];
      const newIndex =
        direction === "up"
          ? Math.max(0, indexItem - 1)
          : Math.min(products.length - 1, indexItem + 1);
      if (
        newIndex === indexItem ||
        newIndex < 0 ||
        newIndex >= products.length
      ) {
        return prevData;
      }
      const temp = products[indexItem];
      products[indexItem] = products[newIndex];
      products[newIndex] = temp;

      // Cập nhật lại sortOrder sau khi di chuyển vị trí
      const updatedProducts = products.map((item, idx) => ({
        ...item,
        sortOrder: idx + 1,
      }));

      newData[indexGroup].tblComboSetProdCommands = updatedProducts;
      return newData;
    });
  };



  const handleUpdateSortOrder = (
    indexGroup: number,
    newSortOrder: number | string
  ) => {
    const numSortOrder =
      typeof newSortOrder === "string"
        ? parseInt(newSortOrder, 10)
        : newSortOrder;

    if (
      isNaN(numSortOrder) ||
      numSortOrder < 1 ||
      numSortOrder > dataGroupItem.length
    ) {
      return; // Ignore invalid input
    }

    setDataGroupItem((prevData) => {
      const newData = [...prevData];
      const currentSortOrder = prevData[indexGroup].sortOrder || indexGroup + 1;
      const conflictingGroupIndex = newData.findIndex(
        (group, idx) => group.sortOrder === numSortOrder && idx !== indexGroup
      );
      if (conflictingGroupIndex !== -1) {
        return newData.map((group, idx) => {
          if (idx === indexGroup) {
            return { ...group, sortOrder: numSortOrder };
          }
          if (idx === conflictingGroupIndex) {
            return { ...group, sortOrder: currentSortOrder };
          }
          return group;
        });
      } else {
        return newData.map((group, idx) => {
          if (idx === indexGroup) {
            return { ...group, sortOrder: numSortOrder };
          }
          return group;
        });
      }
    });
  };

  const toggleProductCollapse = (indexGroup: number) => {
    setOpenedProductLists((prev) => ({
      ...prev,
      [indexGroup]: !prev[indexGroup],
    }));
  };

  const [openedProductLists, setOpenedProductLists] = useState<
    Record<number, boolean>
  >({});

  // Xử lý kéo thả vị trí nhóm
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setDataGroupItem((prev) => {
      const oldIndex = prev.findIndex(
        (group, idx) => (group.id ?? `group-${idx}`) === active.id
      );
      const newIndex = prev.findIndex(
        (group, idx) => (group.id ?? `group-${idx}`) === over.id
      );
      if (oldIndex === -1 || newIndex === -1) return prev;

      const newArr = [...prev];//tạo bản sao mảng nhóm
      const [moved] = newArr.splice(oldIndex, 1);//xóa nhóm ở vị trí cũ
      newArr.splice(newIndex, 0, moved);//chèn nhóm vào vị trí mới

      // Cập nhật lại sortOrder cho từng nhóm
      return newArr.map((group, idx) => ({
        ...group,
        sortOrder: idx + 1,
      }));
    });
  };
  return (
    <>
      <Group justify="space-between">
        <Text fw={700} mt={20} fz={18}>
          Nhóm sản phẩm trong set
        </Text>
        <Box display={"flex"} style={{ columnGap: 8, marginTop: 12 }}>
          {countEmptyGroups() < 3 && (
            <Button onClick={handleAddGroupItem}>Thêm nhóm sản phẩm</Button>
          )}
        </Box>
      </Group>
      <DndContext onDragEnd={handleDragEnd}>
        <SortableContext
          items={dataGroupItem.map((group, idx) => group.id ?? `group-${idx}`)}
        >
          {dataGroupItem?.map((item: any, indexGroup) => {
            const products =
              dataGroupItem[indexGroup]?.tblComboSetProdCommands || [];
            const hasMoreThan6 = products.length > 2; //chỉnh sửa lấy bao nhiêu Sản phẩm hiển thị
            return (
              <SortableGroupItem
                key={item.id}
                indexGroup={indexGroup}
                products={products}
                hasMoreThan6={hasMoreThan6}
                openedProductLists={openedProductLists}
                toggleProductCollapse={toggleProductCollapse}
                dataGroupItem={dataGroupItem}
                setDataGroupItem={setDataGroupItem}
                handleChangeNameComboSet={handleChangeNameComboSet}
                openModal={openModal}
                handleUpdateSortOrder={handleUpdateSortOrder}
                handleRemoveGroup={handleRemoveGroup}
              />
            );
          })}{" "}
        </SortableContext>
      </DndContext>
    </>
  );
};

export default ItemGroupV2;
